import { DynamicObject5, SuperBit_swaggerClient, Vehicle, DynamicObject1 } from './superbit-api-models'
import { SimulatorPageModel, LeadModel, VehicleDataModel, SimulatorOfferModel } from './superbit-api-models'
import { GovData1, GovData2, ManulApiModel } from './ManulApiModel'
import generalSettings from '../json/general-settings.json';

export class SimulatorModel {
    client: any;
    testClient: any;
    serverTestClient: any;

    constructor() {

        const apiUrl = localStorage.getItem('apiUrl');
        var url = apiUrl ? apiUrl : generalSettings.apiUrl;
        //var url = "https://localhost:44333";

        // some generated client methods omit the Authorization header; inject it
        // here (only when absent) so every call through this client is authenticated.
        const authHttp = {
            fetch(input: RequestInfo, init?: RequestInit) {
                const token = localStorage.getItem('AuthToken');
                const headers: any = { ...(init && init.headers ? init.headers : {}) };
                if (token && !headers['Authorization']) {
                    headers['Authorization'] = `Bearer ${token}`;
                }
                return window.fetch(input, { ...(init || {}), headers });
            },
        };

        //this.client = new SuperBit_swaggerClient("http://api.dev-alt1.superbit.co.il");
        //this.client = new SuperBit_swaggerClient("https://localhost:44333");//("https://api.superbit.co.il");
        this.client = new SuperBit_swaggerClient(url, authHttp);
        // this.client = new SuperBit_swaggerClient("https://localhost:44329");
        this.testClient = new SuperBit_swaggerClient(url);//("https://api.superbit.co.il");
        this.testClient = new SuperBit_swaggerClient//("https://api.superbit.co.il");
        // this.testClient = new SuperBit_swaggerClient("http://localhost:3001");

        this.serverTestClient = new SuperBit_swaggerClient(url);//("https://api.superbit.co.il");
        // this.serverTestClient = new SuperBit_swaggerClient("https://localhost:44329");
    }




    getSimulator(leadId: string, offerId: string) {
        return this.client.simulatorIndex(leadId, offerId);
    }

    getInsuranceTypes() {
        return this.client.getAppDictionaryList("InsuranceTypes");
    }

    getPropertyType() {
        return this.client.getAppDictionaryList("PropertyType");
    }

    getInsuranceType() {
        return this.client.getAppDictionaryList("InsuranceType");
    }

    getIdentityTypes() {
        return this.client.getAppDictionaryList("IdentityType");
    }

    getAuthorizedToDriveItems() {
        return this.client.getAppDictionaryList("AuthorizedToDrive");
    }

    // new

    getApartmentPolicyTypes() {
        return this.client.getAppDictionaryList("ApartmentPolicyType");
    }

    getApartmentCoverTypes() {
        return this.client.getAppDictionaryList("ApartmentCoverType");
    }

    getCoveragePercentageTypes() {
        return this.client.getAppDictionaryList("CoveragePercentageType");
    }

    getOrderPlumberTypes() {
        return this.client.getAppDictionaryList("OrderPlumberType");
    }

    getCollectionMethodTypes() {
        return this.client.getAppDictionaryList("CollectionMethodType");
    }

    getCollectionRouteTypes() {
        return this.client.getAppDictionaryList("CollectionRouteType");
    }
    getServicesProviderTypes() {
        return this.client.getAppDictionaryList("ServicesProvider");
    }



    getGenderTypes() {
        return this.client.getAppDictionaryList("Gender");
    }

    getMaritalStatus() {
        return this.client.getAppDictionaryList("MaritalStatus");
    }

    getVehicleOwnership() {
        return this.client.getAppDictionaryList("VehicleOwnership");
        //return this.client.getVehicleOwnership();
    }

    getImpairmentDeductible() {
        return this.client.getAppDictionaryList("ImpairmentDeductible");
        //return this.client.getImpairmentDeductible();
    }

    getRenovationAgentsOffice() {
        return this.client.getAppDictionaryList("RenovationAgentsOffice");
        //return this.client.getRenovationAgentsOffice();
    }

    getRenovationCompany() {
        return this.client.getAppDictionaryList("RenovationCompany");
        //return this.client.getRenovationCompany();
    }

    getPassedTypeOfInsurance() {
        return this.client.getAppDictionaryList("PassedTypeOfInsurance");
        //return this.client.getPassedTypeOfInsurance();
    }

    getInsuranceCompanies() {
        return this.client.getAppDictionaryList("InsuranceCompany");
        //return this.client.getPassedTypeOfInsurance();
    }

    getPolicyTypes() {
        return this.client.getAppDictionaryList("PolicyTypes");
        //return this.client.getPassedTypeOfInsurance();
    }

    getEventTypes() {
        return this.client.getAppDictionaryList("EventType");
        //return this.client.getPassedTypeOfInsurance();
    }

    getAddressTypes() {
        return this.client.getAppDictionaryList("AddressType");
    }


    async customerGetAll() {
        return this.client.customerGetAll();
    }

    async getModelCode(search: string) {
        var modelCodes = (await this.client.leadsModelCodeFind(search)).map((item: DynamicObject1, i: number) => {
            return {
                label: item.label,
                value: item.val,
                text: item.label
            }
        });
        return modelCodes;
    }
    getManufacturers() {
        return this.client.leadsManufacturersGetAll();
        //return this.client.leadsManufacturersGetAll(search);
    }

    getVehicleDetails(subModelId: string) {
        return this.client.leadsGetVehicleDetailsByVehicleSubModelId(subModelId);
    }

    getVehicleModelByManufactureOrSearch(search: string | undefined, manufacturerId: string | undefined) {
        return this.client.leadsVehicleModelsGet(search, manufacturerId);
    }

    getVehicleSubModelByVehicleModelOrSearch(search: string | undefined, vehicleModelId: string | undefined) {
        return this.client.leadsVehicleSubModelsGet(search, vehicleModelId);
    }

    getPostalCode(city: string | undefined, street: string | undefined, houseNumber: number | undefined, entrance: string | undefined, mailbox: string | undefined) {
        console.log('simulatorGetPostalCode-city,street,houseNumber,entrance,mailbox', city, street, houseNumber, entrance, mailbox)
        return this.client.simulatorGetPostalCode(city, street, houseNumber, entrance, mailbox);
    }

    GetAddressByPostalCode(postalCode: string | undefined) {


        return this.client.simulatorGetAddressByPostalCode(postalCode);
    }

    simulatorGetCityIdByCity(city: string | undefined) {
        return this.client.simulatorGetCityIdByCity(city);
    }


    // loadSalesPeople () {
    //     const list = localStorage.getItem('salesPeople');
    //     let salesPeople: any[] = []
    //     if (!list) {
    //         salesPeople = this.client.customerCardGetHandlers();
    //         localStorage.setItem('salesPeople', JSON.stringify(salesPeople))
    //     } else {
    //         salesPeople = JSON.parse(list);
    //     }
    // }
    getCustomerCardHandlers() {
        return this.client.customerCardGetHandlers()
    }
    getCustomerCardAgents() {
        return this.client.customerCardGetAgents()
    }

    getBranches() {
        return this.client.leadsGetBranches();
    }

    getBranchesAndUsers() {
        return this.client.leadsGetBranchesAndUsers();
    }

    getProjectManagerBranches() {
        return this.client.getProjectManagerBranches();
    }

    getAddressesAll() {



        const addresses = this.client.getAddressesAll().then((addresses: any[]) => {
            try {
                const addressesData = this.normalizeAddressData(addresses);
                // console.log('addresses', addressesData);
                localStorage.setItem('cities', JSON.stringify(addressesData));
            } catch (error) {
                console.error('Error normalizing address data:', error);
            }
            return addresses;
        }).catch((error: any) => {
            console.error('Error fetching addresses:', error);
        });

        return addresses;

        // const addressesData = this.normalizeAddressData(addresses);
        // // console.log('addresses', addressesData);
        // localStorage.setItem('cities', JSON.stringify(addressesData));
        // return addresses;
    }

    normalizeAddressData(addresses: any[]) {
        const cities: any[] = [];
        addresses.forEach((address: any) => {
            const cityName = address.city;
            const streetName = address.street;
            const houseNumber = address.houseNumber;
            // if (cityName.startsWith('כפר')) {
            //     console.log('cities', cityName)
            // }

            let cityObject = cities.find((c: any) => c.cityName == cityName);
            if (!cityObject) {
                cities.push({
                    cityName: cityName,
                    streets: []
                });

            }
            let cityIndex = cities.findIndex((c: any) => c.cityName == cityName);

            let streetIndex = cities[cityIndex].streets.findIndex((s: string) => s == streetName);
            if (streetIndex < 0) {
                cities[cityIndex].streets.push(streetName);
            }
            // console.log(cityName, cityIndex, cities)
        });
        addresses.sort((a: any, b: any) => (a.city > b.city) ? 1 : -1);
        // console.log('cities', cities)
        return cities;
    }

    getCitiesAutocomplete() {
        const cities = JSON.parse(localStorage.getItem('cities') as string).map((item: any, i: number) => {
            return {
                label: item.cityName,
                value: item.cityName,
                text: item.cityName
            }
        });
        // 
        const autocompleteData = cities
        return autocompleteData;
    }

    getStreetsAutocomplete(cityName: string) {
        const cities = JSON.parse(localStorage.getItem('cities') as string);
        const city = cities.find((c: any) => cityName == null || cityName == "" || c.cityName == cityName);
        if (city) {
            console.log('cityName', cityName)
            console.log('city', city)
            const autocompleteData = city.streets.map((street: string, i: number) => {
                return {
                    label: street,
                    value: street,
                    text: street
                }
            });
            return autocompleteData;
        } else {
            return [];
        }
    }

    async getCustomerDetailsById(id: string) {
        const costomerDetails = await this.client.customerCardGetCustomerById(id);
        // console.log('addresses', costomerDetails)
        return costomerDetails;
    }

    async getVehicleDetailsByLicenseNumber(licenseNumber: string) {

        if (licenseNumber != null && licenseNumber.length > 0) {
            //var data = await new ManulApiModel().GetGovData1(licenseNumber);

            // var data2 = await new ManulApiModel().GetGovData2(data.degem_nm,data.shnat_yitzur,data.degem_cd);
            //    var data3 = await this.client.simulatorGetLeviItzhakModelCode(licenseNumber, data.shnat_yitzur);
            var data3 = await this.client.simulatorGetVehicleDetails({
                licenseNumber: licenseNumber.trim()//,
                //year: data.shnat_yitzur ? data.shnat_yitzur : '2023'
            });

            //console.log('getVehicleDetailsByLicenseNumber', data, data3)
            const vehicleData = new VehicleData(data3);
            console.log('getVehicleDetailsByLicenseNumber', vehicleData)
            // if (vehicleData.)

            return vehicleData

        }

    }



    async simulatorUpdateVehicleSubModel(licenseNumber: string, vehicleModelId: string) {

        if (licenseNumber != null && licenseNumber.length > 0) {
            //var data = await new ManulApiModel().GetGovData1(licenseNumber);

            // var data2 = await new ManulApiModel().GetGovData2(data.degem_nm,data.shnat_yitzur,data.degem_cd);
            //    var data3 = await this.client.simulatorGetLeviItzhakModelCode(licenseNumber, data.shnat_yitzur);
            var data2 = await this.client.simulatorUpdateVehicleSubModel({
                licenseNumber: licenseNumber.trim(),
                vehicleSubmodelId: vehicleModelId
            });

            //console.log('getVehicleDetailsByLicenseNumber', data, data3)

            return data2

        }

    }

    async getModelDetailsByModelCode(code: string, licenseNumber: string | undefined) {

        var data3 = await this.client.simulatorGetVehicleDetails({
            modelCode: code//,

        });

        //console.log('getVehicleDetailsByLicenseNumber', data, data3)
        const vehicleData = new VehicleData(data3);
        console.log('getVehicleDetailsByLicenseNumber', vehicleData)
        // if (vehicleData.)

        return vehicleData







        // let data: any = null;
        // if (code && code.length>0) {
        //     data = await this.client.leadsGetModelDetailsByModelCode(code,licenseNumber==null || licenseNumber==undefined?null:licenseNumber);
        //     console.log('getVehicleDetailsByLicenseNumber', data);
        // }
        // return data;
    }


    async ayalonGetOffers(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        return this.serverTestClient.ayalonGetOffers(serviceData);
    }

    async ankorGetOffers(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        return this.serverTestClient.ankorGetOffers(serviceData);
    }

    async hachsharaGetOffers(body: SimulatorData | undefined) {

        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        return this.serverTestClient.hachsharaGetOffers(serviceData);
    }

    async harelGetOffers(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        return this.serverTestClient.harelGetOffers(serviceData);
    }

    async shomeraGetOffers(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        return this.serverTestClient.shomeraGetOffers(serviceData);
    }

    async simulatorSaveLead(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        this.serverTestClient.simulatorSaveLead(serviceData);
    }



    async shlomoGetOffers(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        return this.serverTestClient.shlomoGetOffers(serviceData);
    }

    async migdalGetOffers(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        return this.serverTestClient.migdalGetOffers(serviceData);
    }

    async clalGetOffers(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        return this.serverTestClient.clalGetOffers(serviceData);
    }

    async fnxGetOffers(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        return this.serverTestClient.fnxGetOffers(serviceData);
    }

    async menoraGetOffers(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        return this.serverTestClient.menoraGetOffers(serviceData);
    }

    async getRiders(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        return this.serverTestClient.riderGetRidersByConditions(serviceData);
    }

    async recalcSimulator(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        return this.serverTestClient.simulatorReCalculateSimulator(serviceData);
    }

    async saveSimulator(body: SimulatorData | undefined) {
        var serviceData = this.convertFromSimulatorDataToLeadModel(body);
        serviceData = this.fixSimulatorData(serviceData);
        return this.serverTestClient.simulatorSaveSimulator(serviceData);
    }

    async getRoutesByInsuranceCompany(id: string) {
        return this.client.simulatorGetRoutesByInsuranceCompany(id);
    }

    // Simulator settings (system-management) -------------------------------
    async simulatorSettings() {
        return this.client.simulatorSettings();
    }

    async simulatorUpdateSimulatorDetails(body: any | undefined) {
        return this.client.simulatorUpdateSimulatorDetails(body);
    }

    async simulatorUpdateRoutes(body: any[] | undefined) {
        return this.client.simulatorUpdateRoutes(body);
    }

    async userUpdateAgents(body: any[] | undefined) {
        return this.client.userUpdateAgents(body);
    }

    // targeted deletes (not yet in the generated client) — authed GET by id
    private async authedDelete(route: string, id: string) {
        const apiUrl = localStorage.getItem('apiUrl') || generalSettings.apiUrl;
        const token = localStorage.getItem('AuthToken');
        const headers: any = { Accept: 'text/plain' };
        if (token) headers['Authorization'] = `Bearer ${token}`;
        const res = await window.fetch(
            `${apiUrl}/api/engagement/${route}?id=${encodeURIComponent(id)}`,
            { method: 'GET', headers }
        );
        if (!res.ok) throw new Error(`${route} failed: ${res.status}`);
    }

    // Terms & covers (per route) — was the _TermsAndCovers.cshtml modal.
    async simulatorShowTermsAndCovers(insuranceCompanyRouteId: string) {
        return this.client.simulatorShowTermsAndCovers(insuranceCompanyRouteId);
    }

    // Saved as multipart/form-data so the file (IFormFile TemsAndCoversFile) and the
    // rich-text fields bind together on the MVC model. The generated client posts JSON,
    // which can't carry the file, so this call is hand-rolled like authedDelete.
    async simulatorSaveTermsAndCovers(
        routeId: string,
        temsAndCovers: string,
        premiumExpansion: string,
        text: string,
        text2: string,
        file?: File | null
    ) {
        const apiUrl = localStorage.getItem('apiUrl') || generalSettings.apiUrl;
        const token = localStorage.getItem('AuthToken');
        const form = new FormData();
        form.append('Id', routeId);
        form.append('TemsAndCovers', temsAndCovers ?? '');
        form.append('PremiumExpansion', premiumExpansion ?? '');
        form.append('Text', text ?? '');
        form.append('Text2', text2 ?? '');
        if (file) form.append('TemsAndCoversFile', file, file.name);
        const headers: any = {};
        if (token) headers['Authorization'] = `Bearer ${token}`;
        const res = await window.fetch(
            `${apiUrl}/api/engagement/simulatorSaveTermsAndCovers`,
            { method: 'POST', headers, body: form }
        );
        if (!res.ok) throw new Error(`simulatorSaveTermsAndCovers failed: ${res.status}`);
    }

    // Terms & covers (per agent) — was the _TermsAndCoversAgent.cshtml modal.
    async simulatorShowTermsAndCoversAgent(agentDetailsId: string) {
        return this.client.simulatorShowTermsAndCoversAgent(agentDetailsId);
    }

    // multipart/form-data (see simulatorSaveTermsAndCovers for why it's hand-rolled).
    // AgentDetails has a single extra text field (Text); there is no Text2.
    async simulatorSaveTermsAndCoversForAgent(
        agentDetailsId: string,
        temsAndCovers: string,
        premiumExpansion: string,
        text: string,
        file?: File | null
    ) {
        const apiUrl = localStorage.getItem('apiUrl') || generalSettings.apiUrl;
        const token = localStorage.getItem('AuthToken');
        const form = new FormData();
        form.append('Id', agentDetailsId);
        form.append('TemsAndCovers', temsAndCovers ?? '');
        form.append('PremiumExpansion', premiumExpansion ?? '');
        form.append('Text', text ?? '');
        if (file) form.append('TemsAndCoversFile', file, file.name);
        const headers: any = {};
        if (token) headers['Authorization'] = `Bearer ${token}`;
        const res = await window.fetch(
            `${apiUrl}/api/engagement/simulatorSaveTermsAndCoversForAgent`,
            { method: 'POST', headers, body: form }
        );
        if (!res.ok)
            throw new Error(`simulatorSaveTermsAndCoversForAgent failed: ${res.status}`);
    }

    async simulatorDeleteRoute(id: string) {
        return this.authedDelete('simulatorDeleteRoute', id);
    }

    async simulatorDeleteAgent(id: string) {
        return this.authedDelete('simulatorDeleteAgent', id);
    }

    async simulatorDeleteDiscount(discountId: string | undefined) {
        return this.client.simulatorDeleteDiscount(discountId);
    }

    async simulatorUpdateDiscounts(body: any[] | undefined) {
        return this.client.simulatorUpdateDiscounts(body);
    }

    async simulatorGetDiscountForEdit(discountId: string | undefined, insuranceCompanyId: string | undefined) {
        return this.client.simulatorGetDiscountForEdit(discountId, insuranceCompanyId);
    }

    // upsert a single discount (create if Id empty, else update); returns refreshed settings.
    // NOTE: the backend action is reached via the (mis-named) simulatorUpdateLeadCalcDetails route.
    async simulatorUpsertDiscount(body: any | undefined) {
        return this.client.simulatorUpdateLeadCalcDetails(body);
    }

    fixSimulatorData(data: SimulatorPageModel) {
        if (data.recalcOffer) {
            data.recalcOffer.endDate = this.checkDate(data.recalcOffer.endDate);
            data.recalcOffer.createdDate = this.checkDate(data.recalcOffer.createdDate);
            data.recalcOffer.updatedDate = this.checkDate(data.recalcOffer.updatedDate);
            if (data.recalcOffer.lead) {
                data.recalcOffer.lead.createdDate = this.checkDate(data.recalcOffer.lead.createdDate);
                data.recalcOffer.lead.updatedDate = this.checkDate(data.recalcOffer.lead.updatedDate);
                data.recalcOffer.lead.identityCardIssueDate = this.checkDate(data.recalcOffer.lead.identityCardIssueDate);
                data.recalcOffer.lead.simulatorOfferStageDate = this.checkDate(data.recalcOffer.lead.simulatorOfferStageDate);
            }
        }
        return data;
    }


    checkDate = (date: any, newDate?: boolean) => {
        return new Date('1974-01-01') < new Date(date) ? date : new Date();
    }



    convertFromSimulatorDataToLeadModel(body: SimulatorData | undefined): SimulatorPageModel {
        // 
        var pageData = new SimulatorPageModel();
        // var simulatorSideData = getSimulatorData
        var data = new LeadModel();
        data.vehicle = new VehicleDataModel();
        if (body != undefined) {
            data.insuranceType = body.InsuranceType;
            data.deductible = body.deductible;
            data.startDate = body.lead_startDate;
            data.endDate = body.lead_endDate;
            data.id = body.lead_id;
            data.authorizedToDrive = body.AuthorizedToDrive;
            data.postalCode = body.postalCode;
            data.city = body.city;
            data.cityId = body.cityId;
            data.mailBox = body.mailBox;
            data.address = body.address;
            data.driverYoungAge = body.driverYoungAge;
            data.driverYoungBirthDate = body.driverYoungBirthDate;
            data.driverYoungSeniority = body.driverYoungSeniority;
            data.driverYoungSeniorityDate = body.driverYoungSeniorityDate;
            data.driverYoungGender = body.driverYoungGender;
            data.driverYoungMaritalStatus = body.driverYoungMaritalStatus;
            data.driverMainAge = body.driverMainAge;
            data.driverMainBirthDate = body.driverMainBirthDate;
            data.driverMainSeniority = body.driverMainSeniority;
            data.driverMainSeniorityDate = body.driverMainSeniorityDate;
            data.driverMainGender = body.driverMainGender;
            data.driverMainMaritalStatus = body.driverMainMaritalStatus;

            data.driverYoungBirthDateSpecificDate = body.driverYoungBirthDateSpecificDate;
            data.driverMainBirthDateSpecificDate = body.driverMainBirthDateSpecificDate;
            data.driverMainSeniorityDateSpecificDate = body.driverMainSeniorityDateSpecificDate;
            data.driverYoungSeniorityDateSpecificDate = body.driverYoungSeniorityDateSpecificDate;

            data.vehicle.esp = body.esp;
            data.vehicle.fcw = body.fcw;
            data.vehicle.ldw = body.ldw;
            data.vehicle.licenseNumber = body.licenseNumber;
            data.vehicle.modelCode = body.modelCode;
            data.automaticInd = body.automaticInd;
            data.vehicle.carYear = body.carYear;
            data.vehicle.entryToRoadDate = body.entryToRoadDate;
            data.vehicle.vehicleSubModelId = body.vehicleSubModelId;
            //data.vehicle.vehicleSubModel.id = body.vehicleSubModelId
            data.passedTypeOfInsurance1 = body.passedTypeOfInsurance1;
            data.sueNumber1 = body.sueNumber1;
            data.passedTypeOfInsurance2 = body.passedTypeOfInsurance2;
            data.sueNumber2 = body.sueNumber2;
            data.passedTypeOfInsurance3 = body.passedTypeOfInsurance3;
            data.sueNumber3 = body.sueNumber3;
            data.passedTypeOfInsurance4 = body.passedTypeOfInsurance4;
            data.sueNumber4 = body.sueNumber4;
            data.bodyClaimsAmount = body.bodyClaimsAmount;
            data.revocationsAmount = body.revocationsAmount;
            data.noInsurance = body.noInsurance;
            data.vehicleOwnership = body.vehicleOwnership;
            data.impairmentDeductible = body.impairmentDeductible;
            data.renovationAgentsOffice = body.renovationAgentsOffice;
            data.renovationCompany = body.renovationCompany;
            data.mainVehicle = body.mainVehicle;
            data.autodirection = body.autodirection;
            data.driveInShabbat = body.driveInShabbat;
            data.newForOld = body.newForOld;
            data.firstName = body.firstName == null ? "Sara" : body.firstName;
            data.phoneNumber1 = body.phoneNumber1 == null ? "0504117832" : body.phoneNumber1;
            data.street = body.street;
            data.houseNumber = body.houseNumber;
            if (body.lead && body.lead.id) {
                data.id = body.lead.id;
            }
            pageData.lead = data;
            pageData.recalcOffer = body.recalcOffer;
            pageData.riders = body.riders;

        }
        return pageData;



    }



}


export class SimulatorData {
    InsuranceType?: any;
    startDateSelectValue?: any;
    deductible?: any;
    insuranceStartDate?: any;
    lead_startDate?: any;
    lead_endDate?: any;
    lead_id?: any;
    AuthorizedToDrive?: any;
    postalCode?: any;
    city?: any;
    cityId?: number;
    mailBox?: number;
    address?: string;
    street?: string;
    houseNumber?: string;
    driverYoungAge?: any;
    driverYoungBirthDate?: any;
    driverYoungSeniority?: any;
    driverYoungSeniorityDate?: any;
    driverYoungGender?: any;
    driverYoungMaritalStatus?: any;
    driverMainAge?: any;
    driverMainBirthDate?: any;
    driverMainSeniority?: any;
    driverMainSeniorityDate?: any;
    driverMainGender?: any;
    driverMainMaritalStatus?: any;
    esp?: any;
    fcw?: any;
    ldw?: any;
    licenseNumber?: any;
    modelCode?: any;
    automaticInd?: any;
    carYear?: any;
    entryToRoadDate?: any;
    manufacturer?: any;
    manufacturerId?: any;
    vehicleModel?: any;
    vehicleModelId?: any;
    vehicleSubModel?: any;
    vehicleSubModelId?: any;
    passedTypeOfInsurance1?: any;
    sueNumber1?: any;
    passedTypeOfInsurance2?: any;
    sueNumber2?: any;
    passedTypeOfInsurance3?: any;
    sueNumber3?: any;
    passedTypeOfInsurance4?: any;
    sueNumber4?: any;
    sueBody?: any;
    revocationsAmount?: any;
    bodyClaimsAmount?: any;
    noInsurance?: any;
    vehicleOwnership?: any;
    impairmentDeductible?: any;
    renovationAgentsOffice?: any;
    renovationCompany?: any;
    mainVehicle?: any;
    autodirection?: any;
    driveInShabbat?: any;
    newForOld?: any;
    firstName?: any;
    phoneNumber1?: any;
    recalcOffer?: any;
    riders?: any;
    lead?: any;
    driverYoungBirthDateSpecificDate?: boolean;
    driverYoungSeniorityDateSpecificDate?: boolean;
    driverMainBirthDateSpecificDate?: boolean;
    driverMainSeniorityDateSpecificDate?: boolean;

    setData(name: string, value: any) {
        [name] = value;
    }
}

export class VehicleData {
    //govData1?:GovData1;
    //govData2?:GovData2;
    LeviItzhak?: DynamicObject5;

    constructor(LeviItzhak?: DynamicObject5) {
        if (LeviItzhak) {
            this.LeviItzhak = LeviItzhak;
        }
        // if (govData2) {
        //     this.govData2 = govData2;
        // }
        // if (govData1) {
        //     this.govData1 = govData1;
        // }
    }
}





